<template>
    <section
        @change="getParameters(height, outerDiameter, size, width, innerDiameter, wallSize, lenght)"
    >
        <div class="inputs"
            v-if="
            profile == '3' ||
            profile == '4' ||
            profile == '7' ||
            profile == '8' ||
            profile == '9' ||
            profile == '10' ||
            profile == '11'">
                <label for="height">Wysokość - <strong>H</strong> [mm] </label>
                <input type="number" name="height" v-model="height"  />
        </div>
        <div class="inputs" v-if="profile == '1' || profile == '2'">
            <label for="outerDiameter">Średnica zewnętrzna - <strong>H</strong> [mm] </label>
            <input type="number" name="outerDiameter" v-model="outerDiameter" />
        </div>
        <div class="inputs" v-if="profile == '6'">
            <label for="size">Grubość - <strong>H</strong> [mm] </label>
            <input type="number" name="size" v-model="size" />
        </div>
        <div class="inputs"
            v-if="
            profile == '5' ||
            profile == '6' ||
            profile == '7' ||
            profile == '8' ||
            profile == '9' ||
            profile == '10' ||
            profile == '11'">
                <label for="width">Szerokość - <strong>W</strong> [mm] </label>
                <input type="number" name="width" v-model="width"  />
        </div>
        <div class="inputs" v-if="profile == '4'">
            <label for="innerDiameter">Średnica wewnętrzna - <strong>B</strong> [mm]</label>
            <input type="number" name="innerDiameter" v-model="innerDiameter" />
        </div>
        <div class="inputs"
            v-if="
            profile == '2' ||
            profile == '7' ||
            profile == '8' ||
            profile == '9' ||
            profile == '10' ||
            profile == '11'">
                <label for="wallSize">Grubość ściany - <strong>B</strong> [mm]</label>
                <input type="number" name="wallSize" v-model="wallSize"  />
        </div>
        <div class="inputs">
            <label for="lenght">Długość - <strong>L</strong> [mm]</label>
            <input type="number" name="lenght" v-model="lenght"  />
        </div>

    </section>
</template>

<script>
export default {
  name: 'Inputs',
  props: ['profile'],
  data() {
    return {
      height: 0,
      outerDiameter: 0,
      size: 0,
      width: 0,
      innerDiameter: 0,
      wallSize: 0,
      lenght: 1000,
    };
  },
  methods: {
    getParameters(height, outerDiameter, size, width, innerDiameter, wallSize, lenght) {
      this.$emit('parameters', height, outerDiameter, size, width, innerDiameter, wallSize, lenght);
    },
  },
};
</script>

<style>
    .inputs{
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        margin: 0 0 5px 0;
        background: #f2f2f2;
    }
    .inputs label{
        flex: 1 1 66.666%;
        max-width: 66.666%;
        width: 100%;
        text-align: left;
        font-weight: 500;
        font-size: 14px;
        padding: 5px 0 5px 15px;
    }
    .inputs input{
        flex: 1 1 33.333%;
        max-width: 33.333%;
        width: 100%;
        text-align: right;
        background: #fff;
        border: 1px solid #22252C;
        padding:0 15px;
    }

    .inputs ::-webkit-outer-spin-button,
    .inputs ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .inputs input[type="number"]{
        -moz-appearance: textfield;
    }
    .inputs input[readonly] {
        font-weight: 700;
        background: transparent;
        border: 0;
    }
</style>
